/*
This component is used to render the edit pop up window of a list data element.
*/
import React, { useEffect } from "react";
import clsx from 'clsx';
import {
    ServiceDialog,
} from '../../../../../../styling/Styles';
import CreateDataElementSnackBar from '../../../../../CreateDataElementSnackBar';
import EditListComponent from './EditListComponent';
import EditListFunctionsRow from './EditListFunctionsRow';
import GenerateListBlock from './GenerateListBlock';


/*
This is the main component that renders the whole edit data element type list pop up window.
*/
const EditDataListElement = (props) => {
    
    const{
        editor,
        savedPageClicked,
        selectedProject,
    } = props;

    const [init, setInit] = React.useState(false);
    const [clickedEdit, setClickedEdit] = React.useState(false);
    const [openAlert, setOpenAlert] = React.useState(false);
    const [componentsInfo, setComponentsInfo] = React.useState([]);
    const [componentsIds, setComponentsIds] = React.useState([]);
    const [name, setName] = React.useState('');
    const [initListElement, setInitListElement] = React.useState(false);
    const [producedBlockName, setProducedBlockName] = React.useState('');
    const [openSnackBar, setOpenSnackBar] = React.useState(false);
    const [clickedButtonGenerate, setClickedButtonGenerate] = React.useState(false);
    const [deleteComps, setDeleteComps] = React.useState([]);
    const [edited, setEdited] = React.useState(false)

    //  This useEffect add to the grapesJs commands the `open edit list pop up window` command  
    useEffect( () => {
        if(init === false && editor.BlockManager !== undefined){
            editor.Commands.add("edit-data-element-list", {
                run(){
                    savedPageClicked();
                    setClickedEdit(true);
                }
            })
            setInit(true);
        }
    })
    
    /*
    This useEffect parses the whole edited list component and stores the inside components using vars components , typeFields,
    idsImage , idsTitle, idsDescription, idsListElements
    */
    useEffect( () => {

        if(clickedEdit === true){
            setOpenAlert(true);
            setClickedEdit(false);
            setClickedButtonGenerate(false);
            setProducedBlockName("")
            
            const tempComponentsIds = [];
            const tempComponentsInfo = [];

            const selectedComponent = editor.getSelected();

            const insideTbody = selectedComponent.attributes.components.models[0];

            //  Parse every row of the edited list
            insideTbody.attributes.components.models.forEach( (listRow,index) => {
                if(listRow.attributes.type === 'row'){

                    tempComponentsIds.push({rowId : listRow.ccid, insideIds: [-1, -1, -1]})

                    //  Initialize basic info for every row
                    tempComponentsInfo.push({type: 'listElement', info :{
                        imageSrc: '',
                        href: '',
                        hrefChecked: false,
                        targetPageChecked: false,
                        targetPage: '',
                        titleText: '',
                        descriptionText: ''
                    }});
                    //  Parse every inside component inside a row of an edited list and initialize basic info of every inside component
                    listRow.attributes.components.models.forEach( (listInsideColumn) => {
                        listInsideColumn.attributes.components.models.forEach( (insideComponent) => {
                            if(insideComponent.attributes.type === 'image'){
                                tempComponentsIds[index].insideIds[0] = insideComponent.ccid;
                                tempComponentsInfo[index].info.imageSrc = insideComponent.attributes.src;
                                if(insideComponent.attributes.attributes.href !== undefined){
                                    tempComponentsInfo[index].info.href = insideComponent.attributes.attributes.href;
                                    tempComponentsInfo[index].info.hrefChecked = true;
                                }
                                if(insideComponent.attributes.attributes.target_page !== undefined){
                                    tempComponentsInfo[index].info.targetPage = insideComponent.attributes.attributes.target_page;
                                    tempComponentsInfo[index].info.targetPageChecked = true;
                                }
                                
                            }
                            if( insideComponent.attributes.tagName === 'h1'){
                                tempComponentsIds[index].insideIds[1] = insideComponent.ccid;
                                if(insideComponent.attributes.components.models[0] !== undefined && insideComponent.attributes.components.models[0].attributes.content !== '' ){
                                    tempComponentsInfo[index].info.titleText = insideComponent.attributes.components.models[0].attributes.content;
                                }
                                else{
                                    tempComponentsInfo[index].info.titleText = insideComponent.attributes.content;
                                }
                                
                                
                            }
                            if( insideComponent.attributes.tagName === 'p' ){
                                tempComponentsIds[index].insideIds[2] = insideComponent.ccid;
                                
                                if(insideComponent.attributes.components.models[0] !== undefined && insideComponent.attributes.components.models[0].attributes.content !== ''){
                                    tempComponentsInfo[index].info.descriptionText = insideComponent.attributes.components.models[0].attributes.content;
                                }
                                else{
                                    tempComponentsInfo[index].info.descriptionText = insideComponent.attributes.content;
                                }
                                
                            }
                        })
                    })
                }
            })

            //  Read the name of the data element that belongs the edited list. If does not belong to any data element then we give it the name list.
            if(selectedComponent.attributes.attributes.name !== undefined){
                setName(selectedComponent.attributes.attributes.name);
            }
            else{
                setName('List');
            }
            setComponentsInfo(tempComponentsInfo);
            setComponentsIds(tempComponentsIds);
            setInitListElement(true);
            setDeleteComps([]);
        }

    },[clickedEdit])

    useEffect( () => {
        if(edited === true){
            setEdited(false);
        }
    },[edited])

    //  This function closes the edit list pop up window
    const handleCancel = () => {
        
        setOpenAlert(false);
        setClickedEdit(false);
    }

    

    /*
    This function adds a new row to the edited list inside the canvas and stores new row to the componentsInfo and componentsIds vars and
    then fires var edited that causes the rerender of rows and adds the new row to the ui.
    */
    const addListElement = () => {
        
        const tempComponentsInfo =[...componentsInfo];
        tempComponentsInfo.push({type: 'listElement', info :{
            imageSrc: '',
            href: '',
            hrefChecked: false,
            targetPageChecked: false,
            targetPage: '',
            titleText: '',
            descriptionText: ''
        }});
        setComponentsInfo(tempComponentsInfo);

        const tempComponentsIds = [...componentsIds]
        tempComponentsIds.push({rowId : -1, insideIds: [-1, -1, -1]})
        setComponentsIds(tempComponentsIds);
        setEdited(true);

    }


    /*
    This function is connected with 'Generate block' button and when is clicked the edit options are replaced with a different pop up 
    window to give a name for the new block
    */
    const activateGenerateButton = () =>{
        setClickedButtonGenerate(true);
    }

    

    return(
        <> 
            <ServiceDialog
                open={openAlert}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                {clickedButtonGenerate !==  true ?
                    <div>
                        {editor !== undefined && editor.getSelected !== undefined && editor.getSelected() !== undefined
                        ?
                            <div className ={clsx('titlePopUp', 'paddingTitle')}> 
                                Edit data element
                                <div aria-hidden="true" onClick={() => {setOpenAlert(false)}} className={clsx('pop-up-close-btn')}>x</div>
                            </div>
                        :
                            null

                        }
                        <div className = {clsx('paddingTitle')}>
                            <div className={clsx('flexRowDirection', 'spacingTopDiv')}> 
                                <div className={clsx('lightBlue')}> Name: &nbsp; </div>   
                                <div> {name} </div>
                            </div> 
                            <div>
                                {
                                    componentsInfo.map( (componentRow,index) => 
                                        
                                        componentRow.type === 'listElement' &&
                                            <EditListComponent
                                                index={index}
                                                componentsInfo={componentsInfo}
                                                setComponentsInfo={setComponentsInfo}
                                                componentsIds={componentsIds}
                                                setComponentsIds={setComponentsIds}
                                                initListElement={initListElement}
                                                setInitListElement={setInitListElement}
                                                clickedEdit={clickedEdit}
                                                deleteComps={deleteComps}
                                                setDeleteComps={setDeleteComps}
                                                edited={edited}
                                                setEdited={setEdited}
                                                key='RowListDataElement'
                                            />
                                    ) 
                                }
                            </div>
                            <span 
                                className={clsx('teamSelector')} 
                                onClick={() => addListElement()}
                                aria-hidden="true"
                                style={{ display: 'inline-block', marginTop: '1vw'}}
                            >
                                <span 
                                style={{fontSize: '0.7vw'}}
                                className={clsx('lightBlue')}>
                                    Add new list element &nbsp;
                                </span>
                            
                            </span>
                            <EditListFunctionsRow
                                handleCancel={handleCancel}
                                activateGenerateButton={activateGenerateButton}
                                deleteComps={deleteComps}
                                editor={editor}
                                componentsInfo={componentsInfo}
                                componentsIds={componentsIds}
                                setOpenAlert={setOpenAlert}
                                setClickedEdit={setClickedEdit}
                                savedPageClicked={savedPageClicked}
                                selectedProject={selectedProject}
                            />
                        </div>
                    </div>
                    :
                    <GenerateListBlock
                        producedBlockName={producedBlockName}
                        setProducedBlockName={setProducedBlockName}
                        componentsInfo={componentsInfo}
                        name={name}
                        editor={editor}
                        selectedProject={selectedProject}
                        savedPageClicked={savedPageClicked}
                        setOpenAlert={setOpenAlert}
                        setOpenSnackBar={setOpenSnackBar}
                        setClickedButtonGenerate={setClickedButtonGenerate}
                    />
                }
            
            </ServiceDialog>
            <CreateDataElementSnackBar
                open={openSnackBar}
                setOpen={setOpenSnackBar}
                editElement='true'
            />
        </>
    )
}

export default EditDataListElement;